import {
  Component,
  OnInit,
  Inject,
  ChangeDetectorRef
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-issue-seller-personal-ledger',
  standalone: false,
  templateUrl: './issue-seller-personal-ledger.component.html',
  styleUrls: ['./issue-seller-personal-ledger.component.scss'],
})
export class IssueSellerPersonalLedgerComponent implements OnInit {

  getpersonalleddata: any;
  balancecfamt: any;
  reportType: string = '';
  startDate: string = '';
  endDate: string = '';
  offRepName: string = '';
  repname: string = '';
  issueDates: string = '';
  currentDate: any;

  constructor(
    private dialogRef: MatDialogRef<IssueSellerPersonalLedgerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.reportType = this.data?.reportType || '';
    this.filters(); // ✅ call the method
  }

  filters(): void {
    let repname: any = this.data['repName'];

    if (repname != "") {
      repname = [repname];
    }

    const req: any = {
      "rep_name": repname,
      "startDate": this.startDate,
      "endDate": this.endDate,
      "off_rep_name": this.offRepName,
      "issue_seller_name": this.data['name'],
      "issue_date": this.issueDates
    };

    const req1: any = {
      "startDate": this.data['startDate'],
      "endDate": this.data['endDate'],
      "issue_seller_name": this.data['name']
    };
    this.startDate=this.data['startDate']
    this.endDate=this.data['endDate']
    const today = new Date();
    this.currentDate = today.toISOString().split('T')[0]; 
    
   this.service.getissuePersoanlLed(req1).subscribe((data: any) => {
      console.log("Get ledgerdata", data);
      this.getpersonalleddata = data;
      this.balancecfamt = this.getpersonalleddata[0]?.opening_bal || 0;

      for (let data1 of this.getpersonalleddata[0]?.rep_data || []) {
        if (data1.net_amt != null && data1.net_amt !== "") {
          this.balancecfamt = parseFloat(data1.net_amt) + parseFloat(this.balancecfamt);
          data1.act_amt = this.balancecfamt;
        } else if (data1.actual_arc_amt != null && data1.actual_arc_amt !== "") {
          data1.act_amt = parseFloat(this.balancecfamt) - parseFloat(data1.actual_arc_amt);
          this.balancecfamt = data1.act_amt;
        } else if (data1.credit_amt != null && data1.credit_amt !== "") {
          data1.act_amt = parseFloat(this.balancecfamt) - parseFloat(data1.credit_amt);
          this.balancecfamt = data1.act_amt;
        }
      }
    });
  }

  exportExcel(fileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.getpersonalleddata);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data']
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcelFile(excelBuffer, fileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + '.xlsx');
  }
}